import { Box } from '@mui/material';
import { DataGrid, GridColDef, GridRenderCellParams, GridRowsProp, useGridApiRef } from '@mui/x-data-grid';
import React from 'react';
import CustomNoRowsOverlay from '../../../../Common/CustomNoRowsOverlay';
import { formatNumber } from '../../../../Common/FormatNumber';

interface ChartProps {
    title: string;
    id: number;
    height: number;
}

export default function FrequentItems({ title, id, height = 345 }: ChartProps) {
    const apiRef = useGridApiRef();
    const [loading, setLoading] = React.useState(true);
    const [rows, setRows] = React.useState<GridRowsProp>([]);

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'ID', width: 100, headerAlign: 'center', align: 'center' }, 
        { field: 'entity_product_id', headerName: 'SKU Code', width: 150, headerAlign: 'center', align: 'center' },
        { field: 'annual_invoices', headerName: 'Invoices #', width: 100, headerAlign: 'center', align: 'center' },
        { field: 'annual_qty', headerName: 'Qty', width: 100, headerAlign: 'center', align: 'center', 
            renderCell: (params: GridRenderCellParams) => {
                return <span>{new Intl.NumberFormat().format(params.value)}</span>;
            },
        },
        { field: 'annual_sales', headerName: 'Sales ($)', width: 100, headerAlign: 'center', align: 'center', type: 'number',
            renderCell: (params: GridRenderCellParams) => {
                return <span>{formatNumber(params.value)}</span>;
            },
        },
        { field: 'annual_costs', headerName: 'Costs ($)', width: 100, headerAlign: 'center', align: 'center', type: 'number',
            renderCell: (params: GridRenderCellParams) => {
                return <span>{formatNumber(params.value)}</span>;
            },
        },
        { field: 'annual_gp', headerName: 'Gross Profit ($)', width: 100, headerAlign: 'center', align: 'center', type: 'number',
            renderCell: (params: GridRenderCellParams) => {
                return <span>{formatNumber(params.value)}</span>;
            },
        },
        { field: 'annual_gp_pct', headerName: 'Gross Profit (%)', width: 100, headerAlign: 'center', align: 'center', type: 'number',
            renderCell: (params: GridRenderCellParams) => {
                return <span>{params.value.toFixed(2)}%</span>;
            },
        },
        { field: 'velocity_code', headerName: 'Velocity', width: 100, headerAlign: 'center', align: 'center' },
        { field: 'volume_code', headerName: 'Volume', width: 100, headerAlign: 'center', align: 'center' },
    ];

    React.useEffect(() => {
        fetch(`/dashboard/customer-frequent-items/${id}/?entity_id=${localStorage.getItem('entity_id')}`)
        .then(response => response.json())
        .then(data => {
            setRows(data.rows);
            setLoading(false);
        });
    }, []);

    return (
        <Box sx={{ height: '100%', width: '100%', flexDirection: 'row', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <DataGrid
                showToolbar
                loading={loading}
                apiRef={apiRef}
                columns={columns}
                rows={rows}
                columnVisibilityModel={{id: false}}
                pagination
                initialState={{ pagination: { paginationModel: { pageSize: 20, page: 0 }, rowCount: 0 } }}
                pageSizeOptions={[5, 10, 20, 50, 100]}
                sx={{ height: height, width: '100%' }}
                slots={{
                    noRowsOverlay: () => <CustomNoRowsOverlay message="No frequent items found" />
                }}
            />
        </Box>
    );
}